import ApiService from '@/helpers/api.service';
import { Storage } from 'aws-amplify';
import moment from "moment";

const API = new ApiService();
const parentFolder = "billspayment";

// Endpoints

export const state = {
  billsPaymentCategory: [],
  billsPaymentCategoryPage: {
    totalRows: 0,
    totalPage: 0
  },
  billsSellTxn: [],
  billsSellTxnPageInfo: {
    total: 0
  },
  billsDailyIncoming: 0,
  billsDailyOutgoing: 0,
  billsMonthlyIncoming: 0,
  billsMonthlyOutgoing: 0,
  errors: null
}

export const mutations = {
  UPDATE_BILLS_SELL_TXN(state, list){
    state.billsSellTxn = list;
  },
  UPDATE_BILLS_SELL_TXN_PAGE_INFO(state, total){
    state.billsSellTxnPageInfo.total = total;
  },
  UPDATE_BILLS_INCOME(state, data){
    state.billsDailyIncoming = data.dailyIncoming;
    state.billsDailyOutgoing = data.dailyOutgoing;
    state.billsMonthlyIncoming = data.monthlyIncoming;
    state.billsMonthlyOutgoing = data.monthlyOutgoing;
  },
  SET_PROD_ERRORS(state, errors) {
    state.errors = errors;
  }
}

export const actions = {
  actionBillsPayment(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/bills-payment/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            if(Object.prototype.hasOwnProperty.call(data.message, "pageInfo")){
              context.commit('UPDATE_BILLS_SELL_TXN_PAGE_INFO', data.message.pageInfo.total);
            }
            if(Object.prototype.hasOwnProperty.call(data.message, "rows")){
              context.commit('UPDATE_BILLS_SELL_TXN', data.message.rows);
            }
            resolve(data)
          } else {
            reject(data.message)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  actionBillsPaymentCategory(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/bills-payment-category/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve(data)
          } else {
            reject(data.message)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  actionBillsPaymentProvider(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/bills-payment-provider/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve(data)
          } else {
            reject(data.message)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  actionBillsIncome(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/bills-payment/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            context.commit('UPDATE_BILLS_INCOME', data.message);
            resolve(data)
          } else {
            reject(data.message)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  uploadLogo(context, params){
    return new Promise((resolve, reject) => {
      var allowedType = ["jpg","jpeg","png","svg"];
      if(params.type && !allowedType.includes(params.type.toLowerCase())){
        reject("Filetype not allowed");
        return;
      }
      var metadata =  {
        customPrefix: {
          public: ''
        },
        expires: moment().add(30, 'days').toDate(),
      }

      if(params.type == 'svg'){
        metadata['contentType'] = 'image/svg+xml';
      }
      Storage.put(`${parentFolder}/${params.folder}/${params.filename}`, params.base64, metadata)
        .then(stored => {
            console.log(">> Success (Upload Image)",stored);
            resolve(stored.key);
        })
        .catch(err => {
            console.log(">> Err (Upload Image)",err);
            reject(err);
        });
    });
  },
}

export const getters = {

}